import { render, staticRenderFns } from "./SchoolGroupSettings.vue?vue&type=template&id=26231e60"
import script from "./SchoolGroupSettings.ts?vue&type=script&lang=ts&external"
export * from "./SchoolGroupSettings.ts?vue&type=script&lang=ts&external"
import style0 from "./SchoolGroupSettings.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports